import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

import { fetchLanguageFiles } from './redux/head/headActions';
import { MLoader } from './components/molecules';
import Routing from './router/routing';


const mapStateToProps = state => ({
	lang: state.head.language.slice(0, 2),
	languages: state.head.utilities.languages,
	translation: state.head.utilities.translation,
});

class App extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			langUuid: this.getLanguageUuid({
				languages: props.languages,
				lang: props.lang,
			}),
		};
	}

	componentWillReceiveProps(props) {
		if (this.state.lang !== props.lang || this.props.languages !== null) {
			const langUuid = this.getLanguageUuid({ languages: props.languages, lang: props.lang });

			if (langUuid === this.state.langUuid) {
				return;
			}

			this.setState({ langUuid, lang: props.lang });
			this.props.fetchLanguageFiles(langUuid);
		}
	}

	getLanguageUuid({ languages, lang }) { // eslint-disable-line
		if (!languages || !languages.length) {
			return undefined;
		}

		return languages.find(lng => lng.tag.toLowerCase() === lang).uuid;
	}

	render() {
		let body = <MLoader className="article--loader-fullscreen " />;

		if (this.props.translation) {
			body = (
				<IntlProvider locale={this.props.lang} messages={this.props.translation}>
					<Routing />
				</IntlProvider>
			);
		}

		return body;
	}
}

App.propTypes = {
	fetchLanguageFiles: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
	fetchLanguageFiles,
})(App);



// WEBPACK FOOTER //
// ./src/app.js